import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { LayoutTagGetResponse } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { LayoutTagGetRequest } from "../../models/communityTalk/layoutTagGetRequest";

export default class LayoutTagApiRequest {
	/**
	 * 表示タグ取得(`/layouttags`)API
	 * @returns
	 */
	public async getLayoutTags(tenantId: string, request: LayoutTagGetRequest): Promise<LayoutTagGetResponse> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/layouttags`,
			headers: {
				tenantId: tenantId,
			},
			params: request,
			method: "GET",
		};

		return (await ApiBase.request<LayoutTagGetResponse>(options)) as LayoutTagGetResponse;
	}
}
